import { BillingExplorerCSVColumnItem } from "@/store/resource-explorer/selectors/current-resource-explorer/csv/possible-columns/utils/types";
import { ResourceExplorerDataGridView } from "@/store/resource-explorer/utils/types/resourceExplorerDataGrid";
import { CsvSelectedPossibleColumns } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/csv-v2/dialog/utils/types";
import {
  billingExplorerGranularGridViewInitialSelectedCsvColumns,
  billingExplorerTotalGridViewInitialSelectedCsvColumns,
} from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/csv-v2/dialog/utils/constants";

export const getInitialSelectedColumns = (
  columns: BillingExplorerCSVColumnItem[],
  gridView: ResourceExplorerDataGridView | null,
): CsvSelectedPossibleColumns => {
  return columns.reduce((result, item) => {
    if (gridView === "granular") {
      if (
        billingExplorerGranularGridViewInitialSelectedCsvColumns.has(
          item.keyValue,
        ) ||
        item.disabled
      ) {
        result = {
          ...result,
          [item.keyValue]: true,
        };
      }
    } else if (
      billingExplorerTotalGridViewInitialSelectedCsvColumns.has(
        item.keyValue,
      ) ||
      item.disabled
    ) {
      result = {
        ...result,
        [item.keyValue]: true,
      };
    }
    return result;
  }, {} as CsvSelectedPossibleColumns);
};
